import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { LinkContextFilter } from '../models/linkContextModel';
import actionTypes from '../types/linkContextTypes';

export const updateFileList = (fileList: any[]): Action<any> =>
  updateAction(actionTypes.UPDATE_FILE_LIST, fileList);

export const updateAbhaFormData = (formData: any): Action<any> =>
  updateAction(actionTypes.UPDATE_ABHA_FORM_DATA, formData);

export const getAuthModes = (onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.GET_AUTH_MODES, { onSuccess, onError });

export const getClaimDocumentsForABHA = (onSuccess: any): Action<any> =>
  updateAction(actionTypes.GET_CLAIM_DOCS_FOR_ABHA, { onSuccess });

export const setDocumentListForAbha = (documentList: any[]): Action<any> =>
  updateAction(actionTypes.SET_DOC_LIST_FOR_ABHA, documentList);

export const setAuthModes = (modes: string[]): Action<any> =>
  updateAction(actionTypes.SET_AUTH_MODES, modes);

export const generateOTP = (onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.GENERATE_OTP, { onSuccess, onError });

export const verifyOTP = (onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.VERIFY_OTP, { onSuccess, onError });

export const saveDocuments = (onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SAVE_DOCUMENTS, { onSuccess, onError });

export const resetLinkRecords = (): Action<void> =>
  updateAction(actionTypes.RESET_LINK_RECORDS);

export const saveDocsWithoutAbhaAction = (callback: any): Action<any> =>
  updateAction(actionTypes.SAVE_DOCS_WITHOUT_ABHA, { callback });

export const fetchLinkedRecords = (callBack: any): any =>
  updateAction(actionTypes.FETCH_LINKED_RECORDS, { callBack });

export const reloadLinkedRecordsList = (): Action<void> =>
  updateAction(actionTypes.RELOAD_LINKED_RECORDS_LIST);

export const applyLinkedRecordsFilters = (filter: LinkContextFilter): Action<any> =>
  updateAction(actionTypes.APPLY_LINKED_RECORDS_FILTER, filter);

export const updateLinkedRecord = (data: any, onSuccess: any, onError: any): any =>
  updateAction(actionTypes.UPDATE_LINKED_RECORD, { data, onSuccess, onError });

export const getClaimHealthRecords = (data: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.GET_CLAIM_HEALTH_RECORDS, { data, onSuccess, onError });

export const updateAuthFetchError = (status: boolean): Action<any> =>
  updateAction(actionTypes.SET_AUTH_FETCH_MODES_ERROR, status);
